var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsActionDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#EEF6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3618 47.657H47.9183C51.7262 47.657 54.8132 44.5701 54.8132 40.7621V25.4722C54.8132 23.1385 52.9213 21.2466 50.5875 21.2466C48.2537 21.2466 46.3618 23.1385 46.3618 25.4722V47.657Z",
    fill: "#60C2A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4027 29.6979V28.1415C28.4027 24.3335 31.4897 21.2466 35.2976 21.2466L50.5875 21.2466C52.9213 21.2466 54.8132 23.1385 54.8132 25.4722C54.8132 27.806 52.9213 29.6979 50.5875 29.6979L28.4027 29.6979Z",
    fill: "#5DA5D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9625 57.074C21.662 53.7735 21.662 48.4224 24.9625 45.122L47.6101 22.4744C49.2603 20.8241 51.9359 20.8241 53.5861 22.4744C55.2363 24.1246 55.2363 26.8001 53.5861 28.4504L24.9625 57.074Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsActionDownload);
export default __webpack_public_path__ + "static/media/results-action-download.01d4ea83f1832349915cee1a2594e0a0.svg";
export { ForwardRef as ReactComponent };